import { useState } from 'react';

import { useCallback } from 'react';

const ITEMS_PER_PAGE = 10;

export function useDataExtractionPagination() {
	const [pagination, setPagination] = useState({ page: 1, limit: ITEMS_PER_PAGE });

	const changePage = useCallback((page: number) => {
		setPagination((prev) => ({ ...prev, page }));
	}, []);

	const changeLimit = useCallback((limit: number) => {
		setPagination({ page: 1, limit });
	}, []);

	const resetToFirstPage = useCallback(() => {
		setPagination((prev) => ({ ...prev, page: 1 }));
	}, []);

	return {
		pagination,
		changePage,
		changeLimit,
		resetToFirstPage
	};
}
